/* tslint:disable */
/* eslint-disable */
/**
 * Case Management Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AtomicRelationshipRef
 */
export interface AtomicRelationshipRef {
    /**
     * 
     * @type {string}
     * @memberof AtomicRelationshipRef
     */
    'type': AtomicRelationshipRefTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AtomicRelationshipRef
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtomicRelationshipRef
     */
    'relationship': AtomicRelationshipRefRelationshipEnum;
}

export const AtomicRelationshipRefTypeEnum = {
    QUEUES: 'queues'
} as const;

export type AtomicRelationshipRefTypeEnum = typeof AtomicRelationshipRefTypeEnum[keyof typeof AtomicRelationshipRefTypeEnum];
export const AtomicRelationshipRefRelationshipEnum = {
    ATTRIBUTES: 'attributes',
    MEMBERS: 'members',
    TEMPLATE_CONFIGS: 'template_configs'
} as const;

export type AtomicRelationshipRefRelationshipEnum = typeof AtomicRelationshipRefRelationshipEnum[keyof typeof AtomicRelationshipRefRelationshipEnum];

/**
 * 
 * @export
 * @interface Attributes
 */
export interface Attributes {
    /**
     * 
     * @type {string}
     * @memberof Attributes
     */
    'type': AttributesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Attributes
     */
    'assignment_logic': AttributesAssignmentLogicEnum;
}

export const AttributesTypeEnum = {
    USER: 'user'
} as const;

export type AttributesTypeEnum = typeof AttributesTypeEnum[keyof typeof AttributesTypeEnum];
export const AttributesAssignmentLogicEnum = {
    SELF_ASSIGN: 'self-assign'
} as const;

export type AttributesAssignmentLogicEnum = typeof AttributesAssignmentLogicEnum[keyof typeof AttributesAssignmentLogicEnum];

/**
 * 
 * @export
 * @interface CaseListAttributes
 */
export interface CaseListAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'env': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'template_version_etag': string;
    /**
     * 
     * @type {number}
     * @memberof CaseListAttributes
     */
    'template_schema_version': number;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'archived_at': string | null;
}
/**
 * 
 * @export
 * @interface CaseListRelationships
 */
export interface CaseListRelationships {
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'queue': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'template': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'template_version': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'case_properties': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'assignee': JsonApiRelationship;
}
/**
 * 
 * @export
 * @interface CasesResponse
 */
export interface CasesResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseListAttributesCaseListRelationships>}
     * @memberof CasesResponse
     */
    'data': Array<JsonApiResourceObjectCaseListAttributesCaseListRelationships>;
    /**
     * 
     * @type {object}
     * @memberof CasesResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof CasesResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships>}
     * @memberof CasesResponse
     */
    'included'?: Array<JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships> | null;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type': DataTypeEnum;
    /**
     * 
     * @type {QueueCreateAttributes}
     * @memberof Data
     */
    'attributes': QueueCreateAttributes;
    /**
     * 
     * @type {QueueCreateRequestRelationships}
     * @memberof Data
     */
    'relationships': QueueCreateRequestRelationships;
}

export const DataTypeEnum = {
    QUEUES: 'queues'
} as const;

export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];

/**
 * 
 * @export
 * @interface Data1
 */
export interface Data1 {
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'lid'?: string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface Id
 */
export interface Id {
}
/**
 * 
 * @export
 * @interface JsonApiAtomicResult
 */
export interface JsonApiAtomicResult {
    /**
     * 
     * @type {object}
     * @memberof JsonApiAtomicResult
     */
    'data'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof JsonApiAtomicResult
     */
    'meta'?: object | null;
}
/**
 * Resource identifier object
 * @export
 * @interface JsonApiIdentifier
 */
export interface JsonApiIdentifier {
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'lid'?: string | null;
}
/**
 * A relationship object.
 * @export
 * @interface JsonApiRelationship
 */
export interface JsonApiRelationship {
    /**
     * 
     * @type {Data1}
     * @memberof JsonApiRelationship
     */
    'data'?: Data1 | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectBaseModelBaseModel
 */
export interface JsonApiResourceObjectBaseModelBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'attributes': object;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseListAttributesCaseListRelationships
 */
export interface JsonApiResourceObjectCaseListAttributesCaseListRelationships {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'id': string;
    /**
     * 
     * @type {CaseListAttributes}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'attributes': CaseListAttributes;
    /**
     * 
     * @type {CaseListRelationships}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'meta'?: CaseListRelationships | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
 */
export interface JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'attributes': object;
    /**
     * 
     * @type {CaseListRelationships}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'meta'?: CaseListRelationships | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectQueueAttributesQueueResponseRelationships
 */
export interface JsonApiResourceObjectQueueAttributesQueueResponseRelationships {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectQueueAttributesQueueResponseRelationships
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectQueueAttributesQueueResponseRelationships
     */
    'id': string;
    /**
     * 
     * @type {QueueAttributes}
     * @memberof JsonApiResourceObjectQueueAttributesQueueResponseRelationships
     */
    'attributes': QueueAttributes;
    /**
     * 
     * @type {QueueResponseRelationships}
     * @memberof JsonApiResourceObjectQueueAttributesQueueResponseRelationships
     */
    'meta'?: QueueResponseRelationships | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectQueueAttributesQueueResponseRelationships
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectQueueSummaryBaseModel
 */
export interface JsonApiResourceObjectQueueSummaryBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectQueueSummaryBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectQueueSummaryBaseModel
     */
    'id': string;
    /**
     * 
     * @type {QueueSummary}
     * @memberof JsonApiResourceObjectQueueSummaryBaseModel
     */
    'attributes': QueueSummary;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectQueueSummaryBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectQueueSummaryBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny
 */
export interface JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny
     */
    'id': string;
    /**
     * 
     * @type {Attributes}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny
     */
    'attributes': Attributes;
    /**
     * 
     * @type {any}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny
     */
    'meta'?: any;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships
 */
export interface JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships
     */
    'id': string;
    /**
     * 
     * @type {Attributes}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships
     */
    'attributes': Attributes;
    /**
     * 
     * @type {QueueResponseRelationships}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships
     */
    'meta'?: QueueResponseRelationships | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessPaginationLinks
 */
export interface JsonApiSuccessPaginationLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'self': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'next'?: string | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessResponseLinks
 */
export interface JsonApiSuccessResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessResponseLinks
     */
    'self': string;
}
/**
 * 
 * @export
 * @interface QueueAtomicOperationsRequest
 */
export interface QueueAtomicOperationsRequest {
    /**
     * 
     * @type {Array<QueueAtomicOperationsRequestAtomicOperationsInner>}
     * @memberof QueueAtomicOperationsRequest
     */
    'atomic:operations': Array<QueueAtomicOperationsRequestAtomicOperationsInner>;
    /**
     * 
     * @type {Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny>}
     * @memberof QueueAtomicOperationsRequest
     */
    'included'?: Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny> | null;
}
/**
 * @type QueueAtomicOperationsRequestAtomicOperationsInner
 * @export
 */
export type QueueAtomicOperationsRequestAtomicOperationsInner = QueueAttributesUpdateOperation | QueueMembersUpdateOperation | QueueTemplateConfigsUpdateOperation;

/**
 * 
 * @export
 * @interface QueueAtomicResultsResponse
 */
export interface QueueAtomicResultsResponse {
    /**
     * 
     * @type {Array<JsonApiAtomicResult>}
     * @memberof QueueAtomicResultsResponse
     */
    'atomic:results': Array<JsonApiAtomicResult>;
}
/**
 * Attributes for Queue resource.
 * @export
 * @interface QueueAttributes
 */
export interface QueueAttributes {
    /**
     * 
     * @type {string}
     * @memberof QueueAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueueAttributes
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof QueueAttributes
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof QueueAttributes
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface QueueAttributesUpdateOperation
 */
export interface QueueAttributesUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof QueueAttributesUpdateOperation
     */
    'op'?: QueueAttributesUpdateOperationOpEnum;
    /**
     * 
     * @type {AtomicRelationshipRef}
     * @memberof QueueAttributesUpdateOperation
     */
    'ref': AtomicRelationshipRef;
    /**
     * 
     * @type {QueueUpdateAttributes}
     * @memberof QueueAttributesUpdateOperation
     */
    'data': QueueUpdateAttributes;
}

export const QueueAttributesUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type QueueAttributesUpdateOperationOpEnum = typeof QueueAttributesUpdateOperationOpEnum[keyof typeof QueueAttributesUpdateOperationOpEnum];

/**
 * Attributes for Queue creation request.
 * @export
 * @interface QueueCreateAttributes
 */
export interface QueueCreateAttributes {
    /**
     * 
     * @type {string}
     * @memberof QueueCreateAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueueCreateAttributes
     */
    'icon': string;
}
/**
 * JSON:API request model for creating a queue.
 * @export
 * @interface QueueCreateRequest
 */
export interface QueueCreateRequest {
    /**
     * 
     * @type {Data}
     * @memberof QueueCreateRequest
     */
    'data': Data;
    /**
     * 
     * @type {Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny>}
     * @memberof QueueCreateRequest
     */
    'included': Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesAny>;
}
/**
 * Relationships for queue creation.
 * @export
 * @interface QueueCreateRequestRelationships
 */
export interface QueueCreateRequestRelationships {
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof QueueCreateRequestRelationships
     */
    'members': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof QueueCreateRequestRelationships
     */
    'template_configs': JsonApiRelationship;
}
/**
 * JSON:API response model for queue creation.
 * @export
 * @interface QueueCreateResponse
 */
export interface QueueCreateResponse {
    /**
     * 
     * @type {JsonApiResourceObjectQueueAttributesQueueResponseRelationships}
     * @memberof QueueCreateResponse
     */
    'data': JsonApiResourceObjectQueueAttributesQueueResponseRelationships;
    /**
     * 
     * @type {object}
     * @memberof QueueCreateResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof QueueCreateResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships>}
     * @memberof QueueCreateResponse
     */
    'included'?: Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships> | null;
}
/**
 * Attributes for Queue Member resource.
 * @export
 * @interface QueueMemberAttributes
 */
export interface QueueMemberAttributes {
    /**
     * 
     * @type {string}
     * @memberof QueueMemberAttributes
     */
    'type': QueueMemberAttributesTypeEnum;
}

export const QueueMemberAttributesTypeEnum = {
    USER: 'user'
} as const;

export type QueueMemberAttributesTypeEnum = typeof QueueMemberAttributesTypeEnum[keyof typeof QueueMemberAttributesTypeEnum];

/**
 * 
 * @export
 * @interface QueueMembersUpdateOperation
 */
export interface QueueMembersUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof QueueMembersUpdateOperation
     */
    'op'?: QueueMembersUpdateOperationOpEnum;
    /**
     * 
     * @type {AtomicRelationshipRef}
     * @memberof QueueMembersUpdateOperation
     */
    'ref': AtomicRelationshipRef;
    /**
     * 
     * @type {Array<JsonApiIdentifier>}
     * @memberof QueueMembersUpdateOperation
     */
    'data': Array<JsonApiIdentifier>;
}

export const QueueMembersUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type QueueMembersUpdateOperationOpEnum = typeof QueueMembersUpdateOperationOpEnum[keyof typeof QueueMembersUpdateOperationOpEnum];

/**
 * Relationships for queue response.
 * @export
 * @interface QueueResponseRelationships
 */
export interface QueueResponseRelationships {
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof QueueResponseRelationships
     */
    'members': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof QueueResponseRelationships
     */
    'template_configs': JsonApiRelationship;
}
/**
 * 
 * @export
 * @interface QueueSummary
 */
export interface QueueSummary {
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    'unassigned': number;
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    'assigned_to_user': number;
}
/**
 * 
 * @export
 * @interface QueueSummaryResponse
 */
export interface QueueSummaryResponse {
    /**
     * 
     * @type {JsonApiResourceObjectQueueSummaryBaseModel}
     * @memberof QueueSummaryResponse
     */
    'data': JsonApiResourceObjectQueueSummaryBaseModel;
    /**
     * 
     * @type {object}
     * @memberof QueueSummaryResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof QueueSummaryResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof QueueSummaryResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Attributes for Queue Template Config resource.
 * @export
 * @interface QueueTemplateConfigAttributes
 */
export interface QueueTemplateConfigAttributes {
    /**
     * 
     * @type {string}
     * @memberof QueueTemplateConfigAttributes
     */
    'assignment_logic': QueueTemplateConfigAttributesAssignmentLogicEnum;
}

export const QueueTemplateConfigAttributesAssignmentLogicEnum = {
    SELF_ASSIGN: 'self-assign'
} as const;

export type QueueTemplateConfigAttributesAssignmentLogicEnum = typeof QueueTemplateConfigAttributesAssignmentLogicEnum[keyof typeof QueueTemplateConfigAttributesAssignmentLogicEnum];

/**
 * 
 * @export
 * @interface QueueTemplateConfigsUpdateOperation
 */
export interface QueueTemplateConfigsUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof QueueTemplateConfigsUpdateOperation
     */
    'op'?: QueueTemplateConfigsUpdateOperationOpEnum;
    /**
     * 
     * @type {AtomicRelationshipRef}
     * @memberof QueueTemplateConfigsUpdateOperation
     */
    'ref': AtomicRelationshipRef;
    /**
     * 
     * @type {Array<JsonApiIdentifier>}
     * @memberof QueueTemplateConfigsUpdateOperation
     */
    'data': Array<JsonApiIdentifier>;
}

export const QueueTemplateConfigsUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type QueueTemplateConfigsUpdateOperationOpEnum = typeof QueueTemplateConfigsUpdateOperationOpEnum[keyof typeof QueueTemplateConfigsUpdateOperationOpEnum];

/**
 * 
 * @export
 * @interface QueueUpdateAttributes
 */
export interface QueueUpdateAttributes {
    /**
     * 
     * @type {string}
     * @memberof QueueUpdateAttributes
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueueUpdateAttributes
     */
    'icon'?: string | null;
}
/**
 * JSON:API response model for list of queues.
 * @export
 * @interface QueuesResponse
 */
export interface QueuesResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectQueueAttributesQueueResponseRelationships>}
     * @memberof QueuesResponse
     */
    'data': Array<JsonApiResourceObjectQueueAttributesQueueResponseRelationships>;
    /**
     * 
     * @type {object}
     * @memberof QueuesResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof QueuesResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships>}
     * @memberof QueuesResponse
     */
    'included'?: Array<JsonApiResourceObjectUnionQueueMemberAttributesQueueTemplateConfigAttributesQueueResponseRelationships> | null;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * CaseQueuesApi - axios parameter creator
 * @export
 */
export const CaseQueuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Apply atomic operations on a queue (attributes, members, template configs)
         * @param {string} queueId 
         * @param {QueueAtomicOperationsRequest} queueAtomicOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost: async (queueId: string, queueAtomicOperationsRequest: QueueAtomicOperationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost', 'queueId', queueId)
            // verify required parameter 'queueAtomicOperationsRequest' is not null or undefined
            assertParamExists('applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost', 'queueAtomicOperationsRequest', queueAtomicOperationsRequest)
            const localVarPath = `/api/v1/queues/{queue_id}/operations`
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueAtomicOperationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new queue with members and templates
         * @summary Create a new queue
         * @param {QueueCreateRequest} queueCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueueEndpointApiV1QueuesPost: async (queueCreateRequest: QueueCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueCreateRequest' is not null or undefined
            assertParamExists('createQueueEndpointApiV1QueuesPost', 'queueCreateRequest', queueCreateRequest)
            const localVarPath = `/api/v1/queues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a queue by its unique identifier
         * @summary Get a queue by ID
         * @param {string} queueId The unique identifier of the queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueApiV1QueuesQueueIdGet: async (queueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('getQueueApiV1QueuesQueueIdGet', 'queueId', queueId)
            const localVarPath = `/api/v1/queues/{queue_id}`
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return counts of total, unassigned, and assigned-to-user cases for a queue in an environment
         * @summary Get queue summary
         * @param {string} queueId The queue identifier
         * @param {GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum} filterEnv 
         * @param {string} filterUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet: async (queueId: string, filterEnv: GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum, filterUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet', 'queueId', queueId)
            // verify required parameter 'filterEnv' is not null or undefined
            assertParamExists('getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet', 'filterEnv', filterEnv)
            // verify required parameter 'filterUserId' is not null or undefined
            assertParamExists('getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet', 'filterUserId', filterUserId)
            const localVarPath = `/api/v1/queues/{queue_id}/summary`
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (filterEnv !== undefined) {
                localVarQueryParameter['filter[env]'] = filterEnv;
            }

            if (filterUserId !== undefined) {
                localVarQueryParameter['filter[userId]'] = filterUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all queues
         * @summary List all queues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuesApiV1QueuesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/queues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cases in a queue with filters, JSON field filters, and cursor pagination
         * @summary List cases for a queue
         * @param {string} queueId The queue identifier
         * @param {ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum} filterEnv 
         * @param {string | null} [filterAssigneeId] 
         * @param {string | null} [filterCreatedAtGte] 
         * @param {string | null} [filterCreatedAtLte] 
         * @param {string | null} [filterUpdatedAtGte] 
         * @param {string | null} [filterUpdatedAtLte] 
         * @param {string | null} [sort] 
         * @param {number} [pageSize] 
         * @param {string | null} [pageCursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCasesEndpointApiV1QueuesQueueIdCasesGet: async (queueId: string, filterEnv: ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum, filterAssigneeId?: string | null, filterCreatedAtGte?: string | null, filterCreatedAtLte?: string | null, filterUpdatedAtGte?: string | null, filterUpdatedAtLte?: string | null, sort?: string | null, pageSize?: number, pageCursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('listCasesEndpointApiV1QueuesQueueIdCasesGet', 'queueId', queueId)
            // verify required parameter 'filterEnv' is not null or undefined
            assertParamExists('listCasesEndpointApiV1QueuesQueueIdCasesGet', 'filterEnv', filterEnv)
            const localVarPath = `/api/v1/queues/{queue_id}/cases`
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (filterEnv !== undefined) {
                localVarQueryParameter['filter[env]'] = filterEnv;
            }

            if (filterAssigneeId !== undefined) {
                localVarQueryParameter['filter[assignee_id]'] = filterAssigneeId;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[created_at][gte]'] = (filterCreatedAtGte as any instanceof Date) ?
                    (filterCreatedAtGte as any).toISOString() :
                    filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[created_at][lte]'] = (filterCreatedAtLte as any instanceof Date) ?
                    (filterCreatedAtLte as any).toISOString() :
                    filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updated_at][gte]'] = (filterUpdatedAtGte as any instanceof Date) ?
                    (filterUpdatedAtGte as any).toISOString() :
                    filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updated_at][lte]'] = (filterUpdatedAtLte as any instanceof Date) ?
                    (filterUpdatedAtLte as any).toISOString() :
                    filterUpdatedAtLte;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseQueuesApi - functional programming interface
 * @export
 */
export const CaseQueuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseQueuesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Apply atomic operations on a queue (attributes, members, template configs)
         * @param {string} queueId 
         * @param {QueueAtomicOperationsRequest} queueAtomicOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost(queueId: string, queueAtomicOperationsRequest: QueueAtomicOperationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueAtomicResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost(queueId, queueAtomicOperationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueuesApi.applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new queue with members and templates
         * @summary Create a new queue
         * @param {QueueCreateRequest} queueCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQueueEndpointApiV1QueuesPost(queueCreateRequest: QueueCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQueueEndpointApiV1QueuesPost(queueCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueuesApi.createQueueEndpointApiV1QueuesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a queue by its unique identifier
         * @summary Get a queue by ID
         * @param {string} queueId The unique identifier of the queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueueApiV1QueuesQueueIdGet(queueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueueApiV1QueuesQueueIdGet(queueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueuesApi.getQueueApiV1QueuesQueueIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return counts of total, unassigned, and assigned-to-user cases for a queue in an environment
         * @summary Get queue summary
         * @param {string} queueId The queue identifier
         * @param {GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum} filterEnv 
         * @param {string} filterUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet(queueId: string, filterEnv: GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum, filterUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet(queueId, filterEnv, filterUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueuesApi.getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all queues
         * @summary List all queues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueuesApiV1QueuesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueuesApiV1QueuesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueuesApi.getQueuesApiV1QueuesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cases in a queue with filters, JSON field filters, and cursor pagination
         * @summary List cases for a queue
         * @param {string} queueId The queue identifier
         * @param {ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum} filterEnv 
         * @param {string | null} [filterAssigneeId] 
         * @param {string | null} [filterCreatedAtGte] 
         * @param {string | null} [filterCreatedAtLte] 
         * @param {string | null} [filterUpdatedAtGte] 
         * @param {string | null} [filterUpdatedAtLte] 
         * @param {string | null} [sort] 
         * @param {number} [pageSize] 
         * @param {string | null} [pageCursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCasesEndpointApiV1QueuesQueueIdCasesGet(queueId: string, filterEnv: ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum, filterAssigneeId?: string | null, filterCreatedAtGte?: string | null, filterCreatedAtLte?: string | null, filterUpdatedAtGte?: string | null, filterUpdatedAtLte?: string | null, sort?: string | null, pageSize?: number, pageCursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CasesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCasesEndpointApiV1QueuesQueueIdCasesGet(queueId, filterEnv, filterAssigneeId, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, sort, pageSize, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueuesApi.listCasesEndpointApiV1QueuesQueueIdCasesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseQueuesApi - factory interface
 * @export
 */
export const CaseQueuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseQueuesApiFp(configuration)
    return {
        /**
         * 
         * @summary Apply atomic operations on a queue (attributes, members, template configs)
         * @param {CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost(requestParameters: CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueueAtomicResultsResponse> {
            return localVarFp.applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost(requestParameters.queueId, requestParameters.queueAtomicOperationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new queue with members and templates
         * @summary Create a new queue
         * @param {CaseQueuesApiCreateQueueEndpointApiV1QueuesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueueEndpointApiV1QueuesPost(requestParameters: CaseQueuesApiCreateQueueEndpointApiV1QueuesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueueCreateResponse> {
            return localVarFp.createQueueEndpointApiV1QueuesPost(requestParameters.queueCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a queue by its unique identifier
         * @summary Get a queue by ID
         * @param {CaseQueuesApiGetQueueApiV1QueuesQueueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueApiV1QueuesQueueIdGet(requestParameters: CaseQueuesApiGetQueueApiV1QueuesQueueIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueueCreateResponse> {
            return localVarFp.getQueueApiV1QueuesQueueIdGet(requestParameters.queueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return counts of total, unassigned, and assigned-to-user cases for a queue in an environment
         * @summary Get queue summary
         * @param {CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet(requestParameters: CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueueSummaryResponse> {
            return localVarFp.getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet(requestParameters.queueId, requestParameters.filterEnv, requestParameters.filterUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return all queues
         * @summary List all queues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuesApiV1QueuesGet(options?: RawAxiosRequestConfig): AxiosPromise<QueuesResponse> {
            return localVarFp.getQueuesApiV1QueuesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * List cases in a queue with filters, JSON field filters, and cursor pagination
         * @summary List cases for a queue
         * @param {CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCasesEndpointApiV1QueuesQueueIdCasesGet(requestParameters: CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CasesResponse> {
            return localVarFp.listCasesEndpointApiV1QueuesQueueIdCasesGet(requestParameters.queueId, requestParameters.filterEnv, requestParameters.filterAssigneeId, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.sort, requestParameters.pageSize, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost operation in CaseQueuesApi.
 * @export
 * @interface CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPostRequest
 */
export interface CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost
     */
    readonly queueId: string

    /**
     * 
     * @type {QueueAtomicOperationsRequest}
     * @memberof CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost
     */
    readonly queueAtomicOperationsRequest: QueueAtomicOperationsRequest
}

/**
 * Request parameters for createQueueEndpointApiV1QueuesPost operation in CaseQueuesApi.
 * @export
 * @interface CaseQueuesApiCreateQueueEndpointApiV1QueuesPostRequest
 */
export interface CaseQueuesApiCreateQueueEndpointApiV1QueuesPostRequest {
    /**
     * 
     * @type {QueueCreateRequest}
     * @memberof CaseQueuesApiCreateQueueEndpointApiV1QueuesPost
     */
    readonly queueCreateRequest: QueueCreateRequest
}

/**
 * Request parameters for getQueueApiV1QueuesQueueIdGet operation in CaseQueuesApi.
 * @export
 * @interface CaseQueuesApiGetQueueApiV1QueuesQueueIdGetRequest
 */
export interface CaseQueuesApiGetQueueApiV1QueuesQueueIdGetRequest {
    /**
     * The unique identifier of the queue
     * @type {string}
     * @memberof CaseQueuesApiGetQueueApiV1QueuesQueueIdGet
     */
    readonly queueId: string
}

/**
 * Request parameters for getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet operation in CaseQueuesApi.
 * @export
 * @interface CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetRequest
 */
export interface CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetRequest {
    /**
     * The queue identifier
     * @type {string}
     * @memberof CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet
     */
    readonly queueId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet
     */
    readonly filterEnv: GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet
     */
    readonly filterUserId: string
}

/**
 * Request parameters for listCasesEndpointApiV1QueuesQueueIdCasesGet operation in CaseQueuesApi.
 * @export
 * @interface CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGetRequest
 */
export interface CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGetRequest {
    /**
     * The queue identifier
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly queueId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly filterEnv: ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly filterAssigneeId?: string | null

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly filterCreatedAtGte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly filterCreatedAtLte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly filterUpdatedAtGte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly filterUpdatedAtLte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly sort?: string | null

    /**
     * 
     * @type {number}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGet
     */
    readonly pageCursor?: string | null
}

/**
 * CaseQueuesApi - object-oriented interface
 * @export
 * @class CaseQueuesApi
 * @extends {BaseAPI}
 */
export class CaseQueuesApi extends BaseAPI {
    /**
     * 
     * @summary Apply atomic operations on a queue (attributes, members, template configs)
     * @param {CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueuesApi
     */
    public applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost(requestParameters: CaseQueuesApiApplyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPostRequest, options?: RawAxiosRequestConfig) {
        return CaseQueuesApiFp(this.configuration).applyQueueAtomicOperationsApiV1QueuesQueueIdOperationsPost(requestParameters.queueId, requestParameters.queueAtomicOperationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new queue with members and templates
     * @summary Create a new queue
     * @param {CaseQueuesApiCreateQueueEndpointApiV1QueuesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueuesApi
     */
    public createQueueEndpointApiV1QueuesPost(requestParameters: CaseQueuesApiCreateQueueEndpointApiV1QueuesPostRequest, options?: RawAxiosRequestConfig) {
        return CaseQueuesApiFp(this.configuration).createQueueEndpointApiV1QueuesPost(requestParameters.queueCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a queue by its unique identifier
     * @summary Get a queue by ID
     * @param {CaseQueuesApiGetQueueApiV1QueuesQueueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueuesApi
     */
    public getQueueApiV1QueuesQueueIdGet(requestParameters: CaseQueuesApiGetQueueApiV1QueuesQueueIdGetRequest, options?: RawAxiosRequestConfig) {
        return CaseQueuesApiFp(this.configuration).getQueueApiV1QueuesQueueIdGet(requestParameters.queueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return counts of total, unassigned, and assigned-to-user cases for a queue in an environment
     * @summary Get queue summary
     * @param {CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueuesApi
     */
    public getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet(requestParameters: CaseQueuesApiGetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetRequest, options?: RawAxiosRequestConfig) {
        return CaseQueuesApiFp(this.configuration).getQueueSummaryEndpointApiV1QueuesQueueIdSummaryGet(requestParameters.queueId, requestParameters.filterEnv, requestParameters.filterUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all queues
     * @summary List all queues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueuesApi
     */
    public getQueuesApiV1QueuesGet(options?: RawAxiosRequestConfig) {
        return CaseQueuesApiFp(this.configuration).getQueuesApiV1QueuesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cases in a queue with filters, JSON field filters, and cursor pagination
     * @summary List cases for a queue
     * @param {CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueuesApi
     */
    public listCasesEndpointApiV1QueuesQueueIdCasesGet(requestParameters: CaseQueuesApiListCasesEndpointApiV1QueuesQueueIdCasesGetRequest, options?: RawAxiosRequestConfig) {
        return CaseQueuesApiFp(this.configuration).listCasesEndpointApiV1QueuesQueueIdCasesGet(requestParameters.queueId, requestParameters.filterEnv, requestParameters.filterAssigneeId, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.sort, requestParameters.pageSize, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum = {
    LIVE: 'live',
    SANDBOX: 'sandbox'
} as const;
export type GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum = typeof GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum[keyof typeof GetQueueSummaryEndpointApiV1QueuesQueueIdSummaryGetFilterEnvEnum];
/**
 * @export
 */
export const ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum = {
    LIVE: 'live',
    SANDBOX: 'sandbox'
} as const;
export type ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum = typeof ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum[keyof typeof ListCasesEndpointApiV1QueuesQueueIdCasesGetFilterEnvEnum];


